export const FTFVDEFAULT: FormTextFieldValues = { text: '', error: '' }
